// Cache gambar iklan sponsor (billboard). Gambar dimuat sekali per id; saat selesai, pendengar (engine) diberi tahu
// agar sprite billboard dilukis ulang dengan gambar terpasang.
const cache = new Map();   // id → { img, siap }
const pendengar = new Set();

export const urlGambarSponsor = id => `${process.env.REACT_APP_BACKEND_URL}/api/sponsor/gambar/${id}`;

export function gambarSponsor(id) {
  if (!id) return null;
  let e = cache.get(id);
  if (!e) {
    const img = new Image();
    e = { img, siap: false };
    img.onload = () => { e.siap = true; pendengar.forEach(cb => cb(id)); };
    img.onerror = () => { e.gagal = true; };
    img.src = urlGambarSponsor(id);
    cache.set(id, e);
  }
  return e.siap ? e.img : null;
}

export const siapGambarSponsor = id => !!(id && cache.get(id)?.siap);
export function saatGambarSponsorSiap(cb) { pendengar.add(cb); return () => pendengar.delete(cb); }

// Tempel gambar ke bidang panel faceS {u0,u1,vF,z0,z1} (z dalam kelipatan T) — parallelogram di layar → transform affine.
export function tempelPanel(g, P, T, panel, img) {
  const pt = (u, v, z) => [P.top[0] + u * (P.right[0] - P.top[0]) + v * (P.left[0] - P.top[0]), P.top[1] + u * (P.right[1] - P.top[1]) + v * (P.left[1] - P.top[1]) - z];
  const a = pt(panel.u0, panel.vF, panel.z1 * T), b = pt(panel.u1, panel.vF, panel.z1 * T), d = pt(panel.u0, panel.vF, panel.z0 * T);
  const w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
  if (!w || !h) return;
  g.save();
  // basis: x → (a→b), y → (a→d); gambar diskalakan penuh ke panel (cover sederhana: isi seluruh panel)
  g.setTransform(g.getTransform().multiply(new DOMMatrix([(b[0] - a[0]) / w, (b[1] - a[1]) / w, (d[0] - a[0]) / h, (d[1] - a[1]) / h, a[0], a[1]])));
  g.drawImage(img, 0, 0, w, h);
  g.restore();
}
